import { Account } from "../../../../../../../services/cloudchipr.api";

export const getAccountsGroupedByStatus = (
  accounts: Account[] | null,
  enableAddMissingOrgAccountAccessRole: boolean,
) => {
  return accounts?.reduce(
    (result, item) => {
      if (
        item.status === "missing_sub_account_role" &&
        enableAddMissingOrgAccountAccessRole
      ) {
        result = {
          ...result,
          missingSubAccountRole: [...result.missingSubAccountRole, item],
        };
      } else {
        result = {
          ...result,
          common: [...result.common, item],
        };
      }

      return result;
    },
    {
      missingSubAccountRole: [],
      common: [],
    } as {
      missingSubAccountRole: Account[];
      common: Account[];
    },
  );
};
